import { render } from "./FaultStatic.vue?vue&type=template&id=41797175"
import script from "./FaultStatic.vue?vue&type=script&lang=js"
export * from "./FaultStatic.vue?vue&type=script&lang=js"

import "./FaultStatic.vue?vue&type=style&index=0&id=41797175&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__